//请自行添加语言资源
const gateSentryLatest = {
  laneName:'通道',
  plantName:'基地名称',
  plateNo:'车牌',
  createTime: '时间',
  dealStatusDesc: '状态',
  dealResult:'备注',
};
export default gateSentryLatest



// WEBPACK FOOTER //
// ./src/page/bd/gateSentryLatest/lang/gateSentryLatest.zh.js